import { ADD_MOBILE_CONFIGURATION,
    ADD_MOBILE_CONFIGURATION_SUCCESS,
    ADD_MOBILE_CONFIGURATION_FAILURE,
    GET_MOBILE_CONFIGURATION,
    GET_MOBILE_CONFIGURATION_SUCCESS,
    GET_MOBILE_CONFIGURATION_FAILURE
} from "../Constants";

export const AddMobileConfiguration = (payload) => ({
    type: ADD_MOBILE_CONFIGURATION,
    payload
});

export const AddMobileConfigurationSuccess = (payload) => ({
    type: ADD_MOBILE_CONFIGURATION_SUCCESS,
    payload
});

export const AddMobileConfigurationFailure = (payload) => ({
    type: ADD_MOBILE_CONFIGURATION_FAILURE,
    payload
});

export const GetMobileConfiguration = () => ({
    type: GET_MOBILE_CONFIGURATION
});

export const GetMobileConfigurationSuccess = (payload) => ({
    type: GET_MOBILE_CONFIGURATION_SUCCESS,
    payload
});

export const GetMobileConfigurationFailure = (payload) => ({
    type: GET_MOBILE_CONFIGURATION_FAILURE,
    payload
});